import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    dbVersions () {
      return api.get(`db/versions`)
    },

    upgradeDb (request) {
      return api.post(`db/upgrade`, request)
    },

    runScript (request) {
      return api.post(`db/script`, request)
    }
  }
} else {
  module = {
    _versions: {
      db: 1,
      s: 2
    },
    _try: 0,

    dbVersions () {
      return delay(1000)({
        data: this._versions
      })
    },

    upgradeDb (request) {
      if (this._try > 0) {
        this._versions.db = this._versions.s
        return delay(100)({ data: {} })
      }
      this._try = 1
      return delay(100)({
        data: { err: 'Erreur fictive!' }
      })
    }
  }
}

export default module
